// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2837":"41c4d2ad","2963":"64940a85"}[chunkId] + ".chunk.css";
};